<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row type="flex" justify="center">
        <el-col class="pages" :xs="24" :sm="10">
          <p class="pages__title">
            Tipo
            <el-select :value="defaultPage" @change='changePage' placeholder="Select">
              <el-option
                v-for="item in pages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </p>
        </el-col>
        <el-col class="providers" :xs="24" :sm="10">
          <h3 class="providers__title">
            <i class="el-icon-s-data"></i>
            Distribución de pesos
            <el-select :value="carrier" filterable @change='editCarrier' placeholder="Select">
              <el-option
                v-for="item in options"
                :key="item.carrier"
                :label="item.carrier"
                :value="item.carrier">
              </el-option>
            </el-select>
          </h3>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->
    <el-row>
      <el-col :span="20" :offset="2">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/utils/http';
import store from './observables/carrier';

const PAGES = [
  {
    value: 'tracking',
    label: 'Tracking',
  },
  {
    value: 'label',
    label: 'Label',
  },
  {
    value: 'cancel-label',
    label: 'Cancel',
  },
  {
    value: 'rate',
    label: 'Rate',
  },
];

export default {
  data() {
    return {
      defaultPage: 'label',
      options: [],
      pages: PAGES,
    };
  },
  computed: {
    carrier() {
      return store.carrier;
    },
  },
  async created() {
    await this.getCarriers();
    if (this.options.length) this.editCarrier(this.options[0].carrier);
  },
  methods: {
    editCarrier(key) {
      store.carrier = key;
    },
    changePage(key) {
      this.defaultPage = key;
      this.$router.push(`/distributions/${key}`);
    },
    async getCarriers() {
      const { data } = await http.get('/carriers');
      const carries = data;
      this.options = carries;
    },
  },
};
</script>

<style scoped>
.pages {
  text-align: left;
  margin-left: 1em;
}
.pages__title {
  display: inherit;
}
.providers__title, .pages__title {
  color: white;
}
.providers__title {
  margin: 1.17em;
  text-align: center;
}
</style>
